import { Button, Input } from "@thdinc/hpf-shared";
import FormModal from "@/components/modals/FormModal";
import SelectInput from "@/components/selectInput/SelectInput";
import ToggleInput from "@/components/toggle/Toggle";
import { CustomSupply } from "@/interfaces/Package";
import React, { useState } from "react";
import { FaCirclePlus } from "react-icons/fa6";
import deleteIcon from "../../../../assets/icons/deleteIcon.svg";
import { FiEdit2 } from "react-icons/fi";
import { addOnsTypes, QuantityTypes } from "@/constants/CompanyData";
import Dropzone from "@/components/dropzone/DropZone";
import ImageUploadFunDropZone from "@/utils/ImageUploadDropZoneFun";

interface CustomSuppliesComp {
  supplies: CustomSupply[] | null;
  // AddEditSupplyFun: (
  //   supply: CustomSupply,
  //   edit: boolean,
  //   index: string | null,
  //   obj?: CustomSupply
  // ) => void;
  // deleteCustomSupply: (name: string) => void;
  editDefaultSupplyPrice: (e: React.FocusEvent<HTMLInputElement>, id: string, type: "cost" | 'profit' | 'isActive') => void;
  customSupplyTotal: number
  // Rendered on the left of the "Total Amount per Cocktail" row
  headerLeft?: React.ReactNode
}
const initialSupply = {
  id: new Date().getTime().toString(),
  name: "",
  byCustomer: false,
  price: 0,
  cost: 0,
  profit: 0,
  type: "bartender",
  uom: "qty",
  description: "",
  image: "",
  isBartender: false,
  isBeer: false,
  isCocktail: false,
  isWine: false,
};
const CustomSupplies: React.FC<CustomSuppliesComp> = ({
  supplies,
  // AddEditSupplyFun,
  // deleteCustomSupply,
  editDefaultSupplyPrice,
  customSupplyTotal,
  headerLeft
}) => {
  const [suppliesError, setSuppliesError] = useState<string>("");
  const [supplyIsEdit, setSupplyIsEdit] = useState<boolean>(false);
  const [supplyObj, setSupplyObj] = useState<CustomSupply>(initialSupply);
  const [curIndex, setCurIndex] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [costText, setCostText] = useState<string>("");
  const [profitText, setProfitText] = useState<string>("");

  const uploadAddOnImg = (file: any) => {
    console.log(file);
    try {
      const f = ImageUploadFunDropZone(file);
      if (f) {
        setSupplyObj({ ...supplyObj, image: URL.createObjectURL(f), file: f });
      }
    } catch (error: any) {
      console.log("error", error.message);
    }
  };
  const removeAddOnImage = () => {
    setSupplyObj({ ...supplyObj, image: "" });
  };

  // const addCustomSuppyFun = () => {
  //   console.log('add')
  //   if (supplyObj.name && supplyObj.type && supplyObj.profit) {
  //     AddEditSupplyFun(supplyObj, supplyIsEdit, curIndex, supplyObj);
  //     closeModal();
  //   } else if (!supplyObj.name) {
  //     setSuppliesError("Name is required");
  //   } else if (!supplyObj.type) {
  //     setSuppliesError("Type is required");
  //   } else if (!supplyObj.cost) {
  //     setSuppliesError("Cost is required");
  //   } else if (!supplyObj.profit) {
  //     setSuppliesError("Profit is required");
  //   }
  // };
  // const editCustomSupply = (item: CustomSupply) => {
  //   setSupplyObj(item);
  //   setSupplyIsEdit(true);
  //   setIsOpen(true);
  //   setCurIndex(item.id);
  // };

  const closeModal = () => {
    setSupplyIsEdit(false);
    setSupplyObj(initialSupply);
    setCostText("");
    setProfitText("");
    setIsOpen(false);
  };
  return (
    <div className="w-full bg-white rounded-2xl p-5 flex py-2 flex-col   ">
      <FormModal
        overflow="overflow-hidden "
        modalTitle={"Add Custom supply"}
        isOpen={isOpen}
        width="lg:w-3/6 md:w-5/6 w-full"
        height="overflow-y-auto"
        onClose={closeModal}
      >
        <div className="mt-2 px-3">
          <div className="text-end text-xs font-semibold mb-1">
            Per supply: $
            {(
              (supplyObj?.cost as number) + (supplyObj?.profit as number)
            ).toFixed(2)}{" "}
          </div>
          <div className="flex gap-4 justify-between sm:items-start flex-col sm:flex-row items-center">
            <div className="flex-2 ">
              <Dropzone
                image={supplyObj?.image && supplyObj.image}
                imgStyle={"w-24 h-24 rounded-xl"}
                removeImage={removeAddOnImage}
                onDrop={uploadAddOnImg}
              // classname="w-20 h-20 py-2 mr-2 rounded-xl object-cover"
              ></Dropzone>
            </div>

            <div className="flex flex-col gap-1 w-full flex-1 ">
              <div className="flex gap-2  flex-col sm:flex-row">
                <input
                  className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  maxLength={50}
                  value={supplyObj?.name}
                  onChange={(e) =>
                    setSupplyObj({ ...supplyObj, name: e.target.value })
                  }
                  type="text"
                  placeholder="Name"
                />
                <SelectInput
                  border="none"
                  classes="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  rounded="rounded-full"
                  disabled={false}
                  options={addOnsTypes}
                  value={supplyObj.type}
                  onChange={(selectedValue: string) => {
                    setSupplyObj({ ...supplyObj, type: selectedValue });
                  }}
                />
                {/* <SelectInput
                        border="none"
                        classes="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                        rounded="rounded-full"
                        disabled={false}
                        options={addOnsTypes}
                        value={addOnType}
                        onChange={(selectedValue: string) => {
                          setAddOnType(selectedValue);
                        }}
                      /> */}
              </div>

              {/**add cost above it*/}
              <div className="flex gap-2 flex-col sm:flex-row ">
                <input
                  value={costText}
                  className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  onChange={(e) => {
                    setCostText(e.target.value);
                    setSupplyObj({ ...supplyObj, cost: Number(e.target.value) });
                  }}
                  onBlur={(e) => {
                    if (e.target.value === "") return;
                    const clamped = Math.min(Number(e.target.value), 999);
                    const formatted = clamped.toFixed(2);
                    setCostText(formatted);
                    setSupplyObj({ ...supplyObj, cost: Number(formatted) });
                  }}
                  type="text"
                  inputMode="decimal"
                  placeholder="Cost"
                />
                <input
                  value={profitText}
                  className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  onChange={(e) => {
                    setProfitText(e.target.value);
                    setSupplyObj({
                      ...supplyObj,
                      profit: Number(e.target.value),
                    });
                  }}
                  onBlur={(e) => {
                    if (e.target.value === "") return;
                    const clamped = Math.min(Number(e.target.value), 999);
                    const formatted = clamped.toFixed(2);
                    setProfitText(formatted);
                    setSupplyObj({ ...supplyObj, profit: Number(formatted) });
                  }}
                  type="text"
                  inputMode="decimal"
                  placeholder="Profit"
                />
              </div>
              <div className="flex gap-2 flex-col sm:flex-row ">
                <SelectInput
                  border="none"
                  classes="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  rounded="rounded-full"
                  disabled={false}
                  options={QuantityTypes}
                  value={supplyObj.type}
                  onChange={(selectedValue: string) => {
                    setSupplyObj({ ...supplyObj, type: selectedValue });
                  }}
                />
              </div>

              <div className="flex gap-2 flex-col sm:flex-row ">
                <div className=" px-4 py-3 gap-2 flex">
                  <label htmlFor="">Bartender</label>
                  <Input
                    className="cursor-pointer w-4 accent-primary-red"
                    type="checkbox"
                    checked={supplyObj?.isBartender}
                    onChange={(e) =>
                      setSupplyObj({
                        ...supplyObj,
                        isBartender: e.target.checked,
                      })
                    }
                  />
                </div>

                <div className=" px-4 py-3 gap-2 flex">
                  <label htmlFor="">Cocktail</label>
                  <Input
                    className="cursor-pointer w-4 accent-primary-red"
                    type="checkbox"
                    checked={supplyObj?.isCocktail}
                    onChange={(e) =>
                      setSupplyObj({
                        ...supplyObj,
                        isCocktail: e.target.checked,
                      })
                    }
                  />
                </div>
                <div className=" px-4 py-3 gap-2 flex">
                  <label htmlFor="">Wine</label>
                  <Input
                    className="cursor-pointer w-4 accent-primary-red"
                    type="checkbox"
                    checked={supplyObj?.isWine}
                    onChange={(e) =>
                      setSupplyObj({ ...supplyObj, isWine: e.target.checked })
                    }
                  />
                </div>
                <div className=" px-4 py-3 gap-2 flex">
                  <label htmlFor="">Beer</label>
                  <Input
                    className="cursor-pointer w-4 accent-primary-red"
                    type="checkbox"
                    checked={supplyObj?.isBeer}
                    onChange={(e) =>
                      setSupplyObj({ ...supplyObj, isBeer: e.target.checked })
                    }
                  />
                </div>
              </div>
              <div className="flex gap-2 flex-col sm:flex-row items-center">
                <input
                  maxLength={200}
                  className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  value={supplyObj?.description}
                  onChange={(e) =>
                    setSupplyObj({ ...supplyObj, description: e.target.value })
                  }
                  type="text"
                  placeholder="Description"
                />
                <div className="w-full px-4 py-3 gap-2 flex">
                  <label htmlFor="">Add to Customer Shopping list?</label>
                  <Input
                    className="cursor-pointer w-4 accent-primary-red"
                    type="checkbox"
                    checked={supplyObj?.byCustomer}
                    onChange={(e) =>
                      setSupplyObj({
                        ...supplyObj,
                        byCustomer: e.target.checked,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          {suppliesError && (
            <p className="text-primary-red text-xs ">{suppliesError}</p>
          )}
          <div className="flex justify-end mt-2">
            <Button
              // onClick={addCustomSuppyFun}
              type="button"
              classes="text-sm text-white rounded px-3 py-2 bg-primary-red cursor-pointer"
            >
              {supplyIsEdit ? "Update" : "Add"}
            </Button>
          </div>
        </div>
      </FormModal>
      <div className={`font-semibold text-xs my-1 flex items-center gap-2 ${headerLeft ? "justify-between" : "justify-end"}`}>
        {headerLeft}
        <p className="text-base">Total Amount per Cocktail (${Number(customSupplyTotal || 0).toFixed(2)})</p>
      {/* <FaCirclePlus
          onClick={() => setIsOpen(true)}
          className="cursor-pointer text-gray-400 text-xl"
        /> */}
      </div>
      <div className="  bg-gray-100 rounded-xl overflow-y-auto">
        <table className="w-full border-collapse  ">
          <thead>
            <tr className="bg-gray-100 text-left  ">
              <th className="p-3 font-medium ">Supplies</th>
              <th className="p-3 font-medium ">Cost per Cocktail</th>
              <th className="p-3 font-medium ">Profit per Cocktail</th>
              <th className="p-3 font-medium ">Total per Cocktail </th>
              {/* <th className="p-3 font-medium ">Unit of  Measure</th> */}
              {/* <th className="p-3 font-medium ">Action</th> */}
              {/* <th className="p-3 font-medium ">Type</th>
              <th className="p-3 font-medium">Bartender</th>
              <th className="p-3 font-medium">Cocktail</th>
              <th className="p-3 font-medium">Wine</th>
              <th className="p-3 font-medium">Beer</th>
              <th className="p-3 font-medium">
                Add to Customer Shopping list?
              </th> */}
              {/* <th className="p-3 font-medium">Display Price</th> */}
            </tr>
          </thead>
          <tbody>
            {supplies &&
              supplies.map((item, index) => (
                <tr
                  key={item.id ?? index}
                  className="border-b odd:bg-white even:bg-gray-50"
                >
                  <td className="p-3 min-w-36">
                    <div className="flex items-center gap-2">
                      <img
                        src={item.image}
                        className="w-14 h-14 object-cover rounded-md"
                        alt="image"
                      />
                      <p className="capitalize">{item.name}</p>
                    </div>
                  </td>
                  <td className="p-3">
                    <input
                      key={`cost-${item.cost}`}
                      placeholder="$"
                      onBlur={(e) => editDefaultSupplyPrice(e, item.id, "cost",)} className={`${item.cost <= -1 && 'border-red-300 border'} bg-gray-100 rounded-full p-2 max-w-28 `} type="text" defaultValue={(item.cost / 100).toFixed(2)} />
                    <p className="text-xs text-primary-red">{(item.cost <= -1 || isNaN(item.cost)) && 'Cost cannot be less than 0'}</p>
                  </td>
                  <td className="p-3">
                    <input
                      key={`profit-${item.profit}`}
                      placeholder="$"
                      onBlur={(e) => editDefaultSupplyPrice(e, item.id, "profit",)} className={`${item.profit <= -1 && 'border-red-300 border'} bg-gray-100 rounded-full p-2 max-w-28 `} type="text" defaultValue={(item.profit / 100).toFixed(2)} />
                    <p className="text-xs text-primary-red">{(item.profit <= -1 || isNaN(item.profit)) && 'Porfit cannot be less than 0'}</p>

                  </td>
                  <td className="p-3">
                    <p>${((item.cost + item.profit) / 100).toFixed(2)}</p>
                  </td>
                  {/* <td className="p-3">
                    <p>qty</p>
                  </td> */}
                  {/* <td className="p-3">
                    <ToggleInput
                      checked={item?.isActive ?? true} // set default value to true
                      onChange={(e:any) => editDefaultSupplyPrice(e, item.id, 'isActive')}
                    />
                  </td> */}
                  {/* <td className="p-3">
                    {item.type}
                  </td>
                  <td className="p-3">
                    <input
                      type="checkbox"
                      checked={item.isBartender}
                      className="w-4 h-4 accent-primary-red"
                    />
                  </td>
                  <td className="p-3">
                    <input
                      type="checkbox"
                      checked={item.isCocktail}
                      className="w-4 h-4 accent-primary-red"
                    />
                  </td>
                  <td className="p-3">
                    <input
                      type="checkbox"
                      checked={item.isWine}
                      className="w-4 h-4 accent-primary-red"
                    />
                  </td>
                  <td className="p-3">
                    <input
                      type="checkbox"
                      checked={item.isBeer}
                      className="w-4 h-4 accent-primary-red"
                    />
                  </td>
                  <td className="p-3">
                    <input
                      className="w-4 h-4 accent-primary-red"
                      type="checkbox"
                      checked={item.byCustomer}
                    />
                  </td> */}
                  {/* <td className="p-3 flex space-x-3">
                    <div className="p-2 bg-white rounded-full font-bold flex gap-2 cursor-pointer">
                      <img
                        onClick={() => deleteCustomSupply(item.id as string)}
                        src={deleteIcon}
                        width={14}
                        height={14}
                        alt="delete"
                      />
                    </div>
                    <p className="p-2 bg-white rounded-full font-bold flex gap-2 cursor-pointer">
                      <FiEdit2
                        size={15}
                        onClick={() => editCustomSupply(item)}
                      />
                    </p>
                  </td> */}
                </tr>
              ))}
            {/* <tr className="border-b bg-gray-50">
              <td >
                <div className="flex items-baseline">
                  <Dropzone
                    image={supplyObj?.image && supplyObj.image}
                    imgStyle={"w-24 h-24 rounded-xl"}
                    removeImage={removeAddOnImage}
                    onDrop={uploadAddOnImg}
                    // classname="w-20 h-20 py-2 mr-2 rounded-xl object-cover"
                  ></Dropzone>
                  <input
                    type="text"
                    className="border-2 border-t-0 border-r-0 border-l-0 focus:"
                    onChange={(e) =>
                      setSupplyObj({ ...supplyObj, name: e.target.value })
                    }
                  />
                </div>
              </td>
              <td >
              <input
                  value={supplyObj?.cost || ""}
                  className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  onChange={(e) =>
                    setSupplyObj({ ...supplyObj, cost: Number(e.target.value) })
                  }
                  type="number"
                  placeholder="Cost"
                  step={0.01}
                  max={999}
                />
             
              </td>
              <td >
              <input
                  value={supplyObj?.profit || ""}
                  className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  onChange={(e) =>
                    setSupplyObj({
                      ...supplyObj,
                      profit: Number(e.target.value),
                    })
                  }
                  type="number"
                  placeholder="Profit"
                  step={0.01}
                  max={999}
                />
              </td>
              <td >
              <p>{supplyObj.cost + supplyObj?.profit}</p>
              </td>
              <td >
              <SelectInput
                  border="none"
                  classes="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  rounded="rounded-full"
                  disabled={false}
                  options={QuantityTypes}
                  value={supplyObj.uom}
                  onChange={(selectedValue: string) => {
                    setSupplyObj({ ...supplyObj, uom: selectedValue });
                  }}
                />
              </td>

              <td >
              <SelectInput
                  border="none"
                  classes="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  rounded="rounded-full"
                  disabled={false}
                  options={addOnsTypes}
                  value={supplyObj.type}
                  onChange={(selectedValue: string) => {
                    setSupplyObj({ ...supplyObj, type: selectedValue });
                  }}
                />
              </td>
              <td >
              <Input
                    className="w-4 h-4 accent-primary-red cursor-pointer"

                    type="checkbox"
                    checked={supplyObj?.isBartender}
                    onChange={(e) =>
                      setSupplyObj({
                        ...supplyObj,
                        isBartender: e.target.checked,
                      })
                    }
                  />
              </td>
              <td >
              <Input
                    className="w-4 h-4 accent-primary-red cursor-pointer"

                    type="checkbox"
                    checked={supplyObj?.isCocktail}
                    onChange={(e) =>
                      setSupplyObj({
                        ...supplyObj,
                        isCocktail: e.target.checked,
                      })
                    }
                  />
              </td>
              <td >
              <Input
                    className="w-4 h-4 accent-primary-red cursor-pointer"

                    type="checkbox"
                    checked={supplyObj?.isWine}
                    onChange={(e) =>
                      setSupplyObj({ ...supplyObj, isWine: e.target.checked })
                    }
                  />
              </td>
              <td >
                <Input
                    className="w-4 h-4 accent-primary-red cursor-pointer"

                    type="checkbox"
                    checked={supplyObj?.isBeer}
                    onChange={(e) =>
                      setSupplyObj({ ...supplyObj, isBeer: e.target.checked })
                    }
                  />
              </td>
              <td>
              <Input
                                      className="w-4 h-4 accent-primary-red cursor-pointer"

                    type="checkbox"
                    checked={supplyObj?.byCustomer}
                    onChange={(e) =>
                      setSupplyObj({
                        ...supplyObj,
                        byCustomer: e.target.checked,
                      })
                    }
                  />
              </td>
              <td>
              <Button
              onClick={addCustomSuppyFun}
              type="button"
              classes="text-sm text-white rounded px-3 py-2 bg-primary-red cursor-pointer"
            >
              {supplyIsEdit ? "Update" : "Add"}
            </Button>
            {suppliesError && (
            <p className="text-primary-red text-xs ">{suppliesError}</p>
          )}
              </td>
            </tr> */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomSupplies;
